document.addEventListener('DOMContentLoaded', function () {
    menu();
});

function menu() {

    let body = document.querySelector('body');
    let menuMask = document.querySelector('.header-mask');
    let menuPrimaryItems = document.querySelectorAll('.menu-primary-item');
    let menuPrimaryItemLinks = document.querySelectorAll('.menu-primary-item > a');
    let menuSecondaryBasket = document.querySelector('.menu-secondary-item-basket');
    let miniCart = document.querySelector('.header-minicart');
    let predictiveSearch = document.querySelector('#predictive-search');
  
    // Primary Menu Item
    menuPrimaryItemLinks.forEach((menuPrimaryItemLink, i) => {
        menuPrimaryItemLink.addEventListener('click', (event) => {
            event.preventDefault();

            // Close other menus, on same level
            if (!menuPrimaryItemLink.parentElement.classList.contains('is-active')) {
                menuPrimaryItems.forEach((item, i) => {
                    item.classList.remove('is-active');
                });
                menuMask.classList.add('is-active');

                // Close the minicart
                if ( miniCart ) miniCart.classList.remove('is-visible');
              
            } else {
                menuMask.classList.remove('is-active');
            }
            menuPrimaryItemLink.parentElement.classList.toggle('is-active');

            // Close Search
            if ( predictiveSearch ) predictiveSearch.style.display = 'none';
        });
    });

    // Submenu Menu Item
    let menuSubmenuItems = document.querySelectorAll('.menu-submenu-item.has-submenu');
    let menuSubmenuItemLinks = document.querySelectorAll('.menu-submenu-item.has-submenu > a');
    menuSubmenuItemLinks.forEach((menuSubmenuItemLink, i) => {
        menuSubmenuItemLink.addEventListener('click', (event) => {
            event.preventDefault();

            if (!menuSubmenuItemLink.parentElement.classList.contains('is-active')) {
                // Close other submenus, on same level
                menuSubmenuItemLink.parentElement.parentElement.querySelectorAll(':scope > .has-submenu').forEach((menuSubmenuItem, i) => {
                    menuSubmenuItem.classList.remove('is-active');
                });
            }
            menuSubmenuItemLink.parentElement.classList.toggle('is-active');
        });
    });

    // Submenu : Pages
    let menuSubmenuPages = document.querySelectorAll('.menu-submenu-page');
    menuSubmenuPages.forEach((menuSubmenuPage, i) => {

        let menuSubmenuSwiperColumns = menuSubmenuPage.querySelector('.swiper').dataset.columns;
        let menuSubmenuPageSwiper = new Swiper(menuSubmenuPage.querySelector('.swiper'), {
            // Default parameters
            slidesPerView: menuSubmenuSwiperColumns,
            spaceBetween: 16,
            navigation: {
                nextEl: menuSubmenuPage.querySelector('.swiper-button-next'),
                prevEl: menuSubmenuPage.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: menuSubmenuSwiperColumns,
                }
            }
        });
    });

    // Submenu : Mobile : Back
    let menuSubmenuBacks = document.querySelectorAll('.menu-submenu-item-back');
    menuSubmenuBacks.forEach((menuSubmenuBack, i) => {
        menuSubmenuBack.addEventListener('click', (event) => {
            menuSubmenuBack.parentNode.parentNode.classList.remove('is-active');
        });
    });


    // Button : Show Menu : Mobile 
    let buttonShowMenu = document.querySelector('.button-show-menu');
    buttonShowMenu.addEventListener('click', (event) => {
        event.preventDefault();
        body.classList.toggle('show-menu');
        body.classList.remove('show-search');
        menuMask.classList.toggle('is-active');

        // Close Search
        if ( predictiveSearch ) predictiveSearch.style.display = 'none';
    });

    // Button : Show Search : Mobile 
    let buttonShowSearch = document.querySelector('.menu-secondary-item-search');
    let headerSearchInput = document.querySelector('.header-search-input');

    if ( buttonShowSearch ) {
      buttonShowSearch.addEventListener('click', (event) => {
          event.preventDefault();
          if (body.classList.contains('show-search')) {
              body.classList.remove('show-search');
              menuMask.classList.remove('is-active');
          } else {
              body.classList.remove('show-menu');
              body.classList.add('show-search');
              menuMask.classList.remove('is-active');
  
              if ( headerSearchInput ) headerSearchInput.focus();
          }
      });
    }

    // Button : Search submit
    let headerSearchSubmit = document.querySelector('.header-search-button');

    if ( headerSearchSubmit ) {
      headerSearchSubmit.addEventListener('click', (event) => {
        event.preventDefault();
        headerSearchInput.focus();
      });
    }

    // Mask
    menuMask.addEventListener('click', (event) => {
        // Hide Mask
        menuMask.classList.remove('is-active');

        // Close Menu
        document.querySelectorAll('.menu-primary-item.is-active').forEach((menuPrimaryItemLink, i) => {
            menuPrimaryItemLink.classList.remove('is-active');
        });

        // Close Submenu
        document.querySelectorAll('.menu-submenu-item.is-active').forEach((menuSubmenuItem, i) => {
            menuSubmenuItem.classList.remove('is-active');
        });

        // Close minicart
        if ( menuSecondaryBasket ) menuSecondaryBasket.classList.remove('is-active');
        if ( miniCart ) miniCart.classList.remove('is-visible');

        // Close Search
        if ( predictiveSearch ) predictiveSearch.style.display = 'none';
      
        // Remove body class
        body.classList.remove('show-menu');

    });

    // Header Notices
    const headerNotices = new Swiper('.header-notice-messages', {
        direction: 'vertical',
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000
        }
    });

    // Homepage : Sticky Header
    if (body.classList.contains('template-index') || body.classList.contains('has-transparent-header') ) {

        let lastKnownScrollPosition = 0;
        let ticking = false;

        function update_header_class(scrollPos) {
            if (lastKnownScrollPosition > 0) {
                body.classList.remove('has-transparent-header');
            } else {
                body.classList.add('has-transparent-header');
            }
        }

        document.addEventListener("scroll", (event) => {
            lastKnownScrollPosition = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    update_header_class(lastKnownScrollPosition);
                    ticking = false;
                });

                ticking = true;
            }
        });
    }
}